import { ChevronDown, ChevronUp } from 'lucide-react';
import { Menu, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import classNames from 'classnames';
import i18n from '@/settings/i18n';
import { useCollectionPageContext } from '../../hooks/useCollectionPageContext';
import Radio from '@/components/v2/common/Radio';
import { SORT_BY_OPTIONS } from '../../hooks/constants';

const t = i18n.init('collections');

function SortBy({ className }: { className?: string }) {
  const { sortByFilter, onSortByChange } = useCollectionPageContext();

  const selectedFilter = SORT_BY_OPTIONS.find(
    (option) =>
      option.sortBy === sortByFilter.sortBy &&
      option.sortDirection === sortByFilter.sortDirection,
  ) || { label: 'Sort By' };

  return (
    <Menu as="div" className={classNames('relative', className)}>
      {({ open }) => (
        <>
          <Menu.Button className="flex h-10 w-full items-center justify-center gap-2 rounded rounded-l-none border border-gray-500 px-2 focus:outline-none lg:w-[200px] lg:justify-between lg:rounded-l ">
            {t(selectedFilter.label)}
            {open ? (
              <ChevronUp className="h-4 w-4 shrink-0 text-gray-700" />
            ) : (
              <ChevronDown className="h-4 w-4 shrink-0 text-gray-700" />
            )}
          </Menu.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-[70] mt-2 w-full min-w-[300px] origin-top-right rounded-md border border-gray-200 bg-white shadow focus:outline-none">
              {SORT_BY_OPTIONS.map((option) => (
                <Menu.Item key={option.label}>
                  {({ active }) => (
                    <button
                      type="button"
                      onClick={() =>
                        onSortByChange(option.sortBy, option.sortDirection)
                      }
                      className={classNames(
                        `group flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm first:rounded-t last:rounded-b`,
                        {
                          'bg-gray-700/5': active,
                          'text-gray-700': !active,
                          'font-semibold':
                            selectedFilter.label === option.label,
                        },
                      )}
                    >
                      <Radio selected={selectedFilter.label === option.label} />
                      {t(option.label)}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}

export default SortBy;
